import { createClassName, createStyleHelper } from '../../utils/class-names';
import type { FCWithChildren } from '../../utils/component.interface';
import { ContextNavLink } from '../context-nav-link/context-nav-link';

import styles from './pill.module.scss';

const style = createStyleHelper(styles, 'pill');

export enum Border {
    LEFT = 'border-left',
    NONE = 'border-none',
    RIGHT = 'border-right',
    BOTH = 'border-both',
}

export interface IPillProps {
    border?: Border;
    isActive?: boolean;
    href: string;
    className?: string;
}

export const Pill: FCWithChildren<IPillProps> = ({
    className,
    children,
    border = Border.BOTH,
    href,
    isActive: isActiveProp,
}) => {
    return (
        <ContextNavLink
            className={({ isActive }) =>
                createClassName([
                    className,
                    style(undefined, {
                        [border]: true,
                        active: isActive || !!isActiveProp,
                    }),
                ])
            }
            to={href}
        >
            {children}
        </ContextNavLink>
    );
};
